import { render, staticRenderFns } from "./icon-statement.vue?vue&type=template&id=0229972b"
import script from "./icon-statement.vue?vue&type=script&lang=js"
export * from "./icon-statement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports